<nav class="navbar navbar-expand-lg bg-custom boxshadow fixed-top">
  <a class="navbar-brand" routerLink="/">
    <span>
      <img class="logo" src="./assets/images/logo_new.png">
    </span>
  </a>
  <span style="font-size:18px;color:#fff;font-weight:bold;font-family: Lucida Grande, Lucida Sans Unicode, Arial, Helvetica, sans-serif;">{{sitename}}</span>
  <button class="navbar-toggler" (click)="isMenuCollapsed = !isMenuCollapsed">
    &#9776;
  </button>

  <div id="wwtp" class="collapse navbar-collapse" [ngbCollapse]="isMenuCollapsed">

    <ul class="navbar-nav ms-auto">
      <!-- <li class="nav-item mt-14px" ngbDropdown>
        <a class="nav-link text-white operator-top-link nav-dropdown-trigger" ngbDropdownToggle id="dashboard" role="button">
          DASHBOARD <i class="fa fa-angle-down ms-1" aria-hidden="true"></i>
        </a>
        <ul ngbDropdownMenu aria-labelledby="dashboard"
          class="dropdown-menu bg-light shadow user_role border-none user-menus operator-main-dropdown">
          <li ngbDropdown placement="left">
            <button type="button" class="sub-dropdown operator-submenu-trigger" id="processDashboardMenu" ngbDropdownToggle>
              <span>Process Dashboard</span>
              <i class="fa fa-angle-right submenu-arrow" aria-hidden="true"></i>
            </button>
            <div class="dropdown-divider"></div>
            <div ngbDropdownMenu aria-labelledby="processDashboardMenu"
              class="dropdown-menu bg-light user-menus sub-dropdown-menu user_role sub_opex_drop operator-submenu-panel">
              <a ngbDropdownItem routerLink="/">Default Dashboard</a>
              <div class="dropdown-divider"></div>
              <a ngbDropdownItem routerLink="/site/sitedashboard">Custom Dashboard</a>
            </div>
          </li>

          <li ngbDropdown placement="left">
            <button type="button" class="sub-dropdown operator-submenu-trigger" id="opexDashboardMenu" ngbDropdownToggle>
              <span>Opex Dashboard</span>
              <i class="fa fa-angle-right submenu-arrow" aria-hidden="true"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="opexDashboardMenu"
              class="dropdown-menu bg-light user-menus sub-dropdown-menu user_role sub_opex_drop operator-submenu-panel">
              <a ngbDropdownItem routerLink="/dashboard/opexdashboard">Default Dashboard</a>
              <div class="dropdown-divider"></div>
              <a ngbDropdownItem routerLink="/dashboard/customeOpexDashboard">Custom Dashboard</a>
            </div>
          </li>

        </ul>
      </li> -->

      <li class="nav-item mt-14px" ngbDropdown>
        <a class="nav-link text-white operator-top-link" routerLink="/newalerts/alertlist" [queryParams]="{ showTableOnly: true }">ALERTS
        </a>
      </li>


      <li class="nav-item mt-14px" ngbDropdown *ngIf="user?.role == 3">
        <a class="nav-link text-white operator-top-link nav-dropdown-trigger" ngbDropdownToggle id="static" role="button">
          UPLOADS <i class="fa fa-angle-down ms-1" aria-hidden="true"></i>
        </a>
        <ul ngbDropdownMenu aria-labelledby="static"
          class="dropdown-menu bg-light shadow border-none user-menus operator-main-dropdown operator-uploads-dropdown">
          <li>
            <a class="dropdown-item operator-main-item" routerLink="/site/uploads/process" ngbDropdownItem>
              Process Module
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item operator-main-item" routerLink="/site/uploads/opex" ngbDropdownItem>
              Opex Module
            </a>
          </li>
        </ul>
      </li>

      <!-- <li> <a class="nav-link mt-10px"><i class="fa fa-plus-square mt-10px"></i> </a></li> -->
      <li class="nav-item mt-12px" *ngIf="
                siteinfo &&
                siteinfo[0].sitepfd &&
                ['2', '3', '7', '11', '8', '9', '15'].includes(user?.role)
              ">
        <a class="nav-link text-white operator-top-link" routerLink="/site/pdfviewer">View PFD</a>
      </li>
      <li class="nav-item ms-1" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="userauth" role="button">
          <img class="" src="./assets/images/avathar.jpg" height="40"
            style="border-radius: 50%;margin-top: 0px;height: 35px;">
        </a>
        <ul ngbDropdownMenu aria-labelledby="userauth" class="dropdown-menu bg-light top-52px logout shadow user-menus">
          <li ngbDropdown placement="left">
            <a class="sub-dropdown" id="logout" (click)="logout()" ngbDropdownToggle><i class="fa fa-power-off"></i>
              Logout </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>
